import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {Datepicker} from '@techsee/techsee-ui-common/lib/datepicker';
import {IHistoryConsoleController} from '../../controller';
import {CalendarDate, Search} from '../../icons';
import './HistoryConsoleTopBar.scss';

export interface HistoryConsoleTopBarProps {
    ctrl: IHistoryConsoleController;
}

@observer
export class HistoryConsoleTopBar extends TechseeBaseComponent<HistoryConsoleTopBarProps> {
    renderInternal() {
        const {ctrl} = this.props;
        const {state} = ctrl;
        const canSearch = !!state.searchText;

        return (
            <div className='history-console-top-bar'>
                <div className='top-bar-search'>
                    <input
                        type='text'
                        className='search-input'
                        placeholder='Search...'
                        value={state.searchText}
                        onChange={(e) => ctrl.setSearchText(e.target.value)}
                        onKeyDown={(e) => ctrl.onSearchKeyDown(e.key)}
                    />
                    <button
                        type='button'
                        className='search-button'
                        onClick={() => ctrl.onSearch()}
                        disabled={!canSearch}>
                        <span className='search-icon'>{Search}</span>
                    </button>
                </div>

                <div className='top-bar-date-range'>
                    <span className='date-range-icon'>{CalendarDate}</span>
                    <Datepicker
                        key={`start-${state.startDate}`}
                        dateFormat='d MMMM yyyy'
                        onDateChange={(date: Date) =>
                            ctrl.setDateRange(date, state.endDate ? new Date(state.endDate) : null)
                        }
                        placeholderText='Start date'
                        maxDate={state.endDate ? new Date(state.endDate) : new Date()}
                        startDate={state.startDate ? new Date(state.startDate) : undefined}
                    />
                    <span className='date-range-separator'>-</span>
                    <Datepicker
                        key={`end-${state.endDate}`}
                        dateFormat='d MMMM yyyy'
                        onDateChange={(date: Date) =>
                            ctrl.setDateRange(state.startDate ? new Date(state.startDate) : null, date)
                        }
                        placeholderText='End date'
                        maxDate={new Date()}
                        minDate={state.startDate ? new Date(state.startDate) : undefined}
                        startDate={state.endDate ? new Date(state.endDate) : undefined}
                    />
                </div>
            </div>
        );
    }
}
